(function($) {
    $(window).on('load', function(){    
        $('.testimonials-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            prevArrow: '.testimonials-slider-wrapper .slick-prev',
            nextArrow: '.testimonials-slider-wrapper .slick-next',
            infinite: true,
            autoplay: true,
            autoplaySpeed: "7500",
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });

        $(".testimonials-slider .slick-dots button").attr('tabindex', 0);
    });
})(jQuery);